import { render, staticRenderFns } from "./SupervisorDash.vue?vue&type=template&id=7a8782fc&scoped=true&"
import script from "./SupervisorDash.vue?vue&type=script&lang=js&"
export * from "./SupervisorDash.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDash.vue?vue&type=style&index=0&id=7a8782fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8782fc",
  null
  
)

export default component.exports